"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _downshift = _interopRequireDefault(require("downshift"));

require("./DropDown.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function ArrowIcon(_ref) {
  var isOpen = _ref.isOpen;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    preserveAspectRatio: "none",
    width: 16,
    fill: "transparent",
    stroke: "#979797",
    strokeWidth: "1.1px",
    transform: isOpen ? 'rotate(180)' : null
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1,6 L10,15 L19,6"
  }));
}

var DropDown = /*#__PURE__*/function (_React$Component) {
  _inherits(DropDown, _React$Component);

  var _super = _createSuper(DropDown);

  function DropDown() {
    var _this;

    _classCallCheck(this, DropDown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleToggleMenu", function (event) {
      var _event$target, _event$target$attribu;

      ((_event$target = event.target) === null || _event$target === void 0 ? void 0 : (_event$target$attribu = _event$target.attributes) === null || _event$target$attribu === void 0 ? void 0 : _event$target$attribu.disabled) || _this.setState(function (_ref2) {
        var isOpen = _ref2.isOpen;
        return {
          isOpen: !isOpen
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleStateChange", function (changes) {
      var isOpen = changes.isOpen,
          type = changes.type;

      if (type === _downshift["default"].stateChangeTypes.mouseUp) {
        _this.setState({
          isOpen: isOpen
        });
      }
    });

    return _this;
  }

  _createClass(DropDown, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var isOpen = this.state.isOpen;
      var _this$props = this.props,
          hasSelectedRows = _this$props.hasSelectedRows,
          items = _this$props.items,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? function () {} : _this$props$onChange,
          itemToString = _this$props.itemToString,
          children = _this$props.children,
          _this$props$align = _this$props.align,
          align = _this$props$align === void 0 ? 'right' : _this$props$align,
          _this$props$singleSel = _this$props.singleSelect,
          singleSelect = _this$props$singleSel === void 0 ? false : _this$props$singleSel;
      var disableDownloads = items.every(function (item) {
        return item.exporterRequiresRowSelection;
      }) && !hasSelectedRows;
      return /*#__PURE__*/_react["default"].createElement(_downshift["default"], {
        itemToString: itemToString,
        onChange: onChange,
        selectedItem: items.filter(function (item) {
          return item.show;
        }),
        isOpen: isOpen,
        onStateChange: this.handleStateChange
      }, function (_ref3) {
        var getInputProps = _ref3.getInputProps,
            getButtonProps = _ref3.getButtonProps,
            getItemProps = _ref3.getItemProps,
            isOpen = _ref3.isOpen,
            toggleMenu = _ref3.toggleMenu,
            clearSelection = _ref3.clearSelection,
            selectedItem = _ref3.selectedItem,
            inputValue = _ref3.inputValue,
            highlightedIndex = _ref3.highlightedIndex;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "dropDownHeader"
        }, /*#__PURE__*/_react["default"].createElement("button", _extends({
          "aria-label": "Show columns to select",
          className: "dropDownButton"
        }, getButtonProps({
          disabled: disableDownloads,
          onClick: _this2.handleToggleMenu
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: "dropDownButtonContent"
        }, children), /*#__PURE__*/_react["default"].createElement(ArrowIcon, {
          isOpen: isOpen
        })), isOpen && /*#__PURE__*/_react["default"].createElement("div", _extends({
          className: "dropDownContent ".concat(singleSelect ? 'single' : 'multiple'),
          style: {
            right: align === 'right' ? 0 : 'auto',
            left: align === 'right' ? 'auto' : 0
          }
        }, singleSelect && {
          onClick: _this2.handleToggleMenu
        }), items.map(function (item, index) {
          var _getItemProps = getItemProps({
            item: item,
            index: index,
            disabled: item.exporterRequiresRowSelection && !hasSelectedRows
          }),
              id = _getItemProps.id,
              itemProps = _objectWithoutProperties(_getItemProps, ["id"]);

          var label = itemToString(item);

          var labelIsComponent = /*#__PURE__*/_react["default"].isValidElement(label);

          return /*#__PURE__*/_react["default"].createElement("div", _extends({
            className: "dropDownContentElement".concat(labelIsComponent ? ' custom' : ' clickable'),
            key: item.id || id
          }, itemProps), label, !(singleSelect || labelIsComponent) && /*#__PURE__*/_react["default"].createElement("input", {
            readOnly: true,
            type: "checkbox",
            checked: selectedItem.indexOf(item) > -1,
            "aria-label": "Select column ".concat(item.id || (typeof label === 'string' ? label : id))
          }));
        })));
      });
    }
  }]);

  return DropDown;
}(_react["default"].Component);

var _default = DropDown;
exports["default"] = _default;